module.exports = __webpack_public_path__ + "static/media/09-icon.4db077c7.svg";